import React from 'react';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { IHSRCharacter } from '../../../common/model/graphql-types';

interface IProps {
  employee: IHSRCharacter;
  showLabel?: boolean;
  showTags?: boolean;
  showIcon?: boolean;
}

export const HSRCharacterIconNoLink: React.FC<IProps> = ({
  employee,
  showLabel,
  showTags,
  showIcon
}) => {
  const image = employee.smallImage
    ? getImage(employee.smallImage.localFile.childImageSharp)
    : null;
  return (
    <>
      <div
        className={`avatar hsr rarity-${employee.rarity} ${
          showLabel ? showLabel : ''
        }`}
      >
        {image && (
          <GatsbyImage
            className="disable-transition"
            image={image}
            alt={`${employee.name}`}
          />
        )}
      </div>
      {showIcon && (
        <span className="floating-element">
          {employee.element === 'Physical' && (
            <StaticImage
              src="../../../../images/starrail/icons/ele_physical_bg.png"
              alt={employee.element}
            />
          )}
          {employee.element === 'Fire' && (
            <StaticImage
              src="../../../../images/starrail/icons/ele_fire_bg.png"
              alt={employee.element}
            />
          )}
          {employee.element === 'Ice' && (
            <StaticImage
              src="../../../../images/starrail/icons/ele_ice_bg.png"
              alt={employee.element}
            />
          )}
          {employee.element === 'Wind' && (
            <StaticImage
              src="../../../../images/starrail/icons/ele_wind_bg.png"
              alt={employee.element}
            />
          )}
          {employee.element === 'Lightning' && (
            <StaticImage
              src="../../../../images/starrail/icons/ele_lightning_bg.png"
              alt={employee.element}
            />
          )}
          {employee.element === 'Quantum' && (
            <StaticImage
              src="../../../../images/starrail/icons/ele_quantum_bg.png"
              alt={employee.element}
            />
          )}
          {employee.element === 'Imaginary' && (
            <StaticImage
              src="../../../../images/starrail/icons/ele_imaginary_bg.png"
              alt={employee.element}
            />
          )}
        </span>
      )}
      {showLabel && <span className="emp-name">{employee.name}</span>}
      {showLabel && employee.isNew && showTags && (
        <span className="tag new">New</span>
      )}
      {showLabel && !employee.isReleased && showTags && (
        <span className="tag future">Unavailable</span>
      )}
    </>
  );
};
